
import {defineComponent} from 'vue';
import PostItem from './PostItem.vue';

interface Post {
  acf: {
    title: string;
    title_color: string;
    title_position: string;
    hero_background_color: string;
    hero_background_type: string;
    company: string;
    '1_column_image': string;
    '2_column_image': string;
    '3_column_image': string;
    featured: boolean;
  };
  link: string;
}

const getPostImage = (field: any) => {
  return (field && typeof(field) === "string") ? field : '';
}

export default defineComponent({
  name: 'PostGrid',
  components: {
    PostItem
  },
  setup() {
    return {
      getPostImage
    }
  },
  props: {
    posts: Array,
  },
});
